import { Button, IconButton } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Styles, withStyles } from '@mui/styles';

import { theme } from '~/theme';

const buttonStyles: Styles<Theme, object, string> = {
  root: {
    border: '1px solid #cccccc',
    height: '24px',
    fontSize: '15px',
    borderRadius: '2px',
    color: '#336699',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    backgroundColor: '#e9e9ed',
    fontFamily: 'arial, helvetica, sans-serif',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#d0d0d7',
    },
    '& .MuiButton-startIcon': {
      '& .fa': {
        fontSize: 'inherit',
      },
    },
  },
};

const iconButtonStyles: Styles<Theme, object, string> = {
  root: {
    ...buttonStyles.root,
    padding: theme.spacing(1, 0),
    width: '24px',
  },
};

export const LegacyMuiButton = withStyles(buttonStyles)(Button);

export const LegacyMuiIconButton = withStyles(iconButtonStyles)(IconButton);
